/**
 * Single runtime source for the SDK version string.
 * Injected at build time from package.json via Vite `define`.
 */
declare const __MIA_WIDGET_VERSION__: string | undefined;

export const MIA_WIDGET_VERSION: string =
  typeof __MIA_WIDGET_VERSION__ !== 'undefined' && __MIA_WIDGET_VERSION__
    ? __MIA_WIDGET_VERSION__
    : '0.1.2';
